import React from 'react'
import type { PageContext } from '@which/glide-ts-types'
import { GridItem } from '@which/seatbelt'

import type { SubVerticalNewsPageQuery } from '../../../../generated/frontend'
import { useSubVerticalNewsPageLazyQuery } from '../../../../generated/frontend'
import type { PageParams } from '../../../../routes'
import { ArticleListingHeader } from '../../../../shared/components/ArticleListingHeader/ArticleListingHeader'
import { Breadcrumb } from '../../../../shared/components/Breadcrumb/Breadcrumb'
import { CategorySelection } from '../../../../shared/components/CategorySelection/CategorySelection'
import { FetchMore } from '../../../../shared/components/FetchMore'
import { GroupedArticles } from '../../../../shared/components/GroupedArticles/GroupedArticles'
import { CategoryListingLinks } from '../../components/CategoryListingLinks'
import styles from './components.module.scss'

export const getSubVerticalNewsComponents = (
  data: SubVerticalNewsPageQuery['subVerticalPage'],
  pageMeta: PageMeta
) => {
  const {
    meta,
    breadcrumb,
    header,
    newsArticles: { pagedArticles },
    taxonomyHierarchyWithCounts,
  } = data

  return {
    Breadcrumb: () => <Breadcrumb {...{ ...breadcrumb, pageTitle: meta?.title }} />,
    ArticleListingHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <ArticleListingHeader
          name={header.title}
          description={header.intro}
          count={pagedArticles.total}
          className={styles.articleListingHeader}
          articleTypeDescriptor="news"
        />
      </GridItem>
    ),
    PagedArticles: () => (
      <GridItem
        span={{ medium: 10, large: 10 }}
        columnStart={{ medium: 2, large: 2 }}
        className={styles.pagedArticles}
      >
        <FetchMore
          initialData={pagedArticles}
          lazyFetch={useSubVerticalNewsPageLazyQuery}
          lazyFetchVars={pageMeta}
          dataTarget="subVerticalPage.newsArticles.pagedArticles"
          dataKey="articles"
        >
          <GroupedArticles />
        </FetchMore>
      </GridItem>
    ),
    CategorySelection: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <CategorySelection taxonomyHierarchyWithCounts={taxonomyHierarchyWithCounts} />
      </GridItem>
    ),
    CategoryListingLinks: () => (
      <GridItem
        span={{ medium: 10, large: 10 }}
        columnStart={{ medium: 2, large: 2 }}
        className={styles.categoryListingLinks}
      >
        <CategoryListingLinks taxonomyHierarchyWithCounts={taxonomyHierarchyWithCounts} />
      </GridItem>
    ),
  }
}

///////// IMPLEMENTATION /////////

type PageMeta = Partial<PageParams> & {
  url?: string
  context?: PageContext | string
}
